module.exports = __webpack_public_path__ + "564adc7c91ecaa935fa57279726cffc7.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/edh-logo-light.svg
// module id = 984
// module chunks = 0